/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function EllipsisVerticalIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "ellipsis-vertical", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 12.5, cy: 6.5, r: 1.5, fill: "currentColor" }),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 1.5, fill: "currentColor" }),
        React.createElement("circle", { cx: 12.5, cy: 18.5, r: 1.5, fill: "currentColor" })));
}
const ForwardRef = React.forwardRef(EllipsisVerticalIcon);
export default ForwardRef;
//# sourceMappingURL=ellipsisVerticalIcon.js.map